import React from 'react';
import { TextInput } from '@/components/common/text-input';
import { useTranslation } from 'react-i18next';
import { ConfirmModal } from '@/components/common/confirm-modal';
import { TextButton } from '@/components/common/text-button';
import { cn } from '@/lib/utils';
import { agentInfoHooks } from '@/manager/manager/agent-workflow-subscription-manager';
import { LoadingOverlay } from '@/components/common/loading-overlay';
import { WorkflowSkeleton } from './workflow-skeleton';

/** 工作流 */
export const Workflow: React.FC = () => {
  const { t } = useTranslation();

  const { agentWorkflow, loading } = agentInfoHooks.useAgentWorkflowSubscriptionData();
  const { updateWorkflow, onValueChange, loading: updateLoading, workflowError, workflowAddressError, resetError } = agentInfoHooks.useUpdateAgentWorkflow();
  const { isChanged } = agentInfoHooks.useAgentWorkflowChanged();
  const { resetAgentWorkflow } = agentInfoHooks.useAgentAction();
  const { next, showConfirmModal, setShowConfirmModal, isTriggeredByRouter, triggerManualConfirm } = agentInfoHooks.useListenerBeforeAction('workflow');

  agentInfoHooks.useListenerAfterAction('workflow');

  const handleSave = async () => {
    await updateWorkflow()
  }

  const handleCancel = () => {
    if (isChanged) {
      triggerManualConfirm();
    }
  }

  const handleCancelConfirm = () => {
    setShowConfirmModal(false);
    resetAgentWorkflow();
    resetError();
    if (isTriggeredByRouter) {
      next();
    }
  }

  return (
    <div className='relative h-64'>
      <div className='flex-1 flex-shrink-0 overflow-y-auto rounded-lg border'>
        <table className="w-full rounded-t-lg">
          <thead className='bg-gray-50 sticky top-0 border-b border-gray-200 h-11'>
            <tr className="bg-gray-50">
              <th className="px-6 py-3 text-left text-sm font-semibold text-[rgba(102,112,133,1)] w-96">{t('agent_dashboard.workflow.workflow_Name')}</th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-[rgba(102,112,133,1)]">{t('agent_dashboard.workflow.workflow_address')}</th>
            </tr>
          </thead>
          <tbody className=''>
            {loading && <WorkflowSkeleton />}
            {!loading && <tr className='h-[4.75rem]'>
              <td className="px-6 py-3 text-sm text-gray-700 border-t border-gray-200 w-96">
                <TextInput
                  value={agentWorkflow.workflow}
                  className='w-[22.13rem]'
                  onChange={(e) => onValueChange('workflow', e.target.value)}
                  disabled={updateLoading}
                  error={!!workflowError}
                  helperText={workflowError}
                />
              </td>
              <td className="px-6 py-3 text-sm text-gray-700 border-t border-gray-200">
                <TextInput
                  value={agentWorkflow.workflowAddress}
                  onChange={(e) => onValueChange('workflowAddress', e.target.value)}
                  disabled={updateLoading}
                  error={!!workflowAddressError}
                  helperText={workflowAddressError}
                />
              </td>
            </tr>}
          </tbody>
        </table>
      </div>
      <div className='flex justify-end mt-4 space-x-3'>
        <TextButton
          label={t('agent_dashboard.confirm_modal.cancel')}
          onClick={handleCancel}
          className={cn(
            '!w-20 h-10 bg-white',
            'font-semibold text-sm !text-[rgba(65,70,81,1)]',
            'border border-[rgba(213, 215, 218, 1)] hover:bg-gray-50',
          )}
        />
        <TextButton
          label={t('agent_dashboard.confirm_modal.save')}
          onClick={handleSave}
          disabled={updateLoading || !isChanged}
          className={cn(
            '!w-[4.063rem] h-10 !bg-[rgba(117,66,247,1)]',
            'font-semibold text-sm text-white',
            'border-none border-[rgba(213, 215, 218, 1)] hover:!bg-[#7542f7eb]',
          )}
        />
      </div>
      <LoadingOverlay loading={updateLoading} />
      <ConfirmModal
        open={showConfirmModal}
        title={t('agent_dashboard.confirm_modal.cancel_title')}
        description={t('agent_dashboard.confirm_modal.cancel_desc')}
        cancel={t('agent_dashboard.confirm_modal.cancel')}
        confirm={t('agent_dashboard.confirm_modal.confirm')}
        onConfirm={handleCancelConfirm}
        onOpenChange={setShowConfirmModal}
      />
    </div>
  );
};